<si-footer [copyright]="'Siemens AG ' + year" [links]="footerLinks" />
